export default __webpack_public_path__ + "static/media/017-maps-and-flags.1246adcb.png";